export const REGISTRATION_ENDPOINTS = {
  register: `/register`,
  groups: `/groups?tenant=${process.env.TAH_TENANT}`,
};
